<template>
<div>
    <NavigationMenu />

    <header class="bg-gradient-to-r from-green-700 to-green-600 shadow-lg">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-center gap-3">
          <div class="flex items-center justify-center w-12 h-12 rounded-xl bg-white bg-opacity-20 backdrop-blur-sm">
            <i class="fas fa-trophy text-2xl text-white"></i>
          </div>
          <div class="text-center sm:text-left">
            <h1 class="text-3xl font-bold text-white">
              Bolão do Brasileiro
            </h1>
            <p class="hidden sm:block text-green-100 text-sm mt-0.5">
              Regras e pontuação do bolão
            </p>
          </div>
        </div>
      </div>
    </header>

    <div class="container mx-auto lg:flex mt-4 justify-between px-2 sm:p-0 sm:mt-4">
        <NavigationBetting />
        
        <div class="w-full sm:w-8/12 lg:w-9/12 mx-auto mr-0">
          <!-- Card principal -->
          <div class="bg-white rounded-xl shadow-lg overflow-hidden">
            
            <!-- Seção: Envio de Palpites -->
            <div class="border-b border-gray-200">
              <div class="bg-gradient-to-r from-green-50 to-green-100 px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
                    <i class="fas fa-paper-plane text-white"></i>
                  </div>
                  <h2 class="text-xl font-bold text-gray-900">Envio de Palpites</h2>
                </div>
              </div>
              <div class="px-6 py-6">
                <ol class="space-y-4">
                  <li class="flex gap-3">
                    <span class="flex-shrink-0 w-6 h-6 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-sm font-bold">1</span>
                    <p class="text-gray-700 leading-relaxed">
                      Os palpites podem ser enviados no grupo do WhatsApp ou diretamente pelo App. Assim que a tabela da rodada for postada os palpites estão liberados. Não esquecer de colocar o seu nome no final do palpite.
                    </p>
                  </li>
                  <li class="flex gap-3">
                    <span class="flex-shrink-0 w-6 h-6 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-sm font-bold">2</span>
                    <p class="text-gray-700 leading-relaxed">
                      Os palpites estarão liberados até o início da primeira partida da rodada. Exemplo: Primeiro jogo iniciado às 17h, palpite poderá ser postado até as 16:59h. A partir do início da rodada qualquer palpite será ignorado.
                    </p>
                  </li>
                  <li class="flex gap-3">
                    <span class="flex-shrink-0 w-6 h-6 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-sm font-bold">3</span>
                    <p class="text-gray-700 leading-relaxed">
                      Em caso de partida adiada, o jogo será retirado da cartela e os palpites referente ao jogo serão anulados, e assim que a partida for remarcada será enviada uma nova tabela de palpite.
                    </p>
                  </li>
                  <li class="flex gap-3">
                    <span class="flex-shrink-0 w-6 h-6 bg-green-100 text-green-700 rounded-full flex items-center justify-center text-sm font-bold">4</span>
                    <p class="text-gray-700 leading-relaxed">
                      O Palpite do atleta após ser postado no grupo ou cadastrado no app, não poderá ser alterado, valerá portanto a primeira cartela postada por cada jogador, será permitida apenas correção com relação a erros de digitação, por exemplo, jogador com a intenção de colocar 2x0, mas acabar colocando 20x0. A administração estará avaliando cada situação.
                    </p>
                  </li>
                </ol>
              </div>
            </div>

            <!-- Seção: Pontuação -->
            <div class="border-b border-gray-200">
              <div class="bg-gradient-to-r from-blue-50 to-blue-100 px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                    <i class="fas fa-star text-white"></i>
                  </div>
                  <h2 class="text-xl font-bold text-gray-900">Sistema de Pontuação</h2>
                </div>
              </div>
              <div class="px-6 py-6">
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <!-- Placar Exato -->
                  <div class="bg-green-50 border-2 border-green-200 rounded-xl p-4 text-center">
                    <div class="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i class="fas fa-bullseye text-white text-xl"></i>
                    </div>
                    <div class="text-3xl font-bold text-green-700 mb-1">100</div>
                    <div class="text-sm font-medium text-gray-700">pontos</div>
                    <div class="text-xs text-gray-600 mt-2">Placar Exato</div>
                  </div>

                  <!-- Vencedor -->
                  <div class="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-4 text-center">
                    <div class="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i class="fas fa-trophy text-white text-xl"></i>
                    </div>
                    <div class="text-3xl font-bold text-yellow-700 mb-1">50</div>
                    <div class="text-sm font-medium text-gray-700">pontos</div>
                    <div class="text-xs text-gray-600 mt-2">Acertar Vencedor</div>
                  </div>

                  <!-- Erro -->
                  <div class="bg-red-50 border-2 border-red-200 rounded-xl p-4 text-center">
                    <div class="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i class="fas fa-times text-white text-xl"></i>
                    </div>
                    <div class="text-3xl font-bold text-red-700 mb-1">0</div>
                    <div class="text-sm font-medium text-gray-700">pontos</div>
                    <div class="text-xs text-gray-600 mt-2">Erro no Palpite</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Seção: Critérios de Desempate -->
            <div class="border-b border-gray-200">
              <div class="bg-gradient-to-r from-purple-50 to-purple-100 px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center">
                    <i class="fas fa-balance-scale text-white"></i>
                  </div>
                  <h2 class="text-xl font-bold text-gray-900">Critérios de Desempate</h2>
                </div>
              </div>
              <div class="px-6 py-6">
                <ol class="space-y-3">
                  <li class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                    <span class="flex-shrink-0 w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">1º</span>
                    <span class="text-gray-700 font-medium">Total de pontos</span>
                  </li>
                  <li class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                    <span class="flex-shrink-0 w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">2º</span>
                    <span class="text-gray-700 font-medium">Total de placares cravados</span>
                  </li>
                  <li class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                    <span class="flex-shrink-0 w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">3º</span>
                    <span class="text-gray-700 font-medium">Pagamento total do bolão realizado anteriormente ao adversário direto</span>
                  </li>
                  <li class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                    <span class="flex-shrink-0 w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold">4º</span>
                    <span class="text-gray-700 font-medium">Quantidades de rodadas que o jogador ficou a frente do adversário direto</span>
                  </li>
                </ol>
              </div>
            </div>

            <!-- Seção: Premiação -->
            <div>
              <div class="bg-gradient-to-r from-amber-50 to-amber-100 px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-amber-600 rounded-lg flex items-center justify-center">
                    <i class="fas fa-medal text-white"></i>
                  </div>
                  <h2 class="text-xl font-bold text-gray-900">Premiação</h2>
                </div>
              </div>
              <div class="px-6 py-6">
                <!-- Disclaimer -->
                <div class="mb-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg">
                  <div class="flex items-start gap-3">
                    <i class="fas fa-info-circle text-blue-600 mt-0.5"></i>
                    <div>
                      <p class="text-sm text-blue-900 font-medium">
                        <strong>Atenção:</strong> Consulte os valores atualizados da premiação no grupo do WhatsApp.
                      </p>
                      <p class="text-xs text-blue-700 mt-1">
                        Os valores podem variar de acordo com o número de participantes e regras específicas do ano.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Grid de Premiação -->
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  <div class="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl p-4 text-center shadow-lg">
                    <div class="text-2xl mb-2">🥇</div>
                    <div class="text-sm font-bold text-yellow-900">1º Lugar</div>
                    <div class="text-xs text-yellow-800 mt-1">Consultar grupo</div>
                  </div>
                  
                  <div class="bg-gradient-to-br from-gray-300 to-gray-400 rounded-xl p-4 text-center shadow-lg">
                    <div class="text-2xl mb-2">🥈</div>
                    <div class="text-sm font-bold text-gray-900">2º Lugar</div>
                    <div class="text-xs text-gray-700 mt-1">Consultar grupo</div>
                  </div>
                  
                  <div class="bg-gradient-to-br from-orange-400 to-orange-500 rounded-xl p-4 text-center shadow-lg">
                    <div class="text-2xl mb-2">🥉</div>
                    <div class="text-sm font-bold text-orange-900">3º Lugar</div>
                    <div class="text-xs text-orange-800 mt-1">Consultar grupo</div>
                  </div>

                  <div class="bg-gradient-to-br from-blue-400 to-blue-500 rounded-xl p-4 text-center shadow-md">
                    <div class="text-2xl mb-2">🏆</div>
                    <div class="text-sm font-bold text-blue-900">4º Lugar</div>
                    <div class="text-xs text-blue-800 mt-1">Consultar grupo</div>
                  </div>

                  <div class="bg-gradient-to-br from-green-400 to-green-500 rounded-xl p-4 text-center shadow-md">
                    <div class="text-2xl mb-2">🎖️</div>
                    <div class="text-sm font-bold text-green-900">5º Lugar</div>
                    <div class="text-xs text-green-800 mt-1">Consultar grupo</div>
                  </div>

                  <div class="bg-gradient-to-br from-purple-400 to-purple-500 rounded-xl p-4 text-center shadow-md">
                    <div class="text-2xl mb-2">⭐</div>
                    <div class="text-sm font-bold text-purple-900">6º Lugar</div>
                    <div class="text-xs text-purple-800 mt-1">Consultar grupo</div>
                  </div>

                  <div class="bg-gradient-to-br from-pink-400 to-pink-500 rounded-xl p-4 text-center shadow-md">
                    <div class="text-2xl mb-2">🎯</div>
                    <div class="text-sm font-bold text-pink-900">7º Lugar</div>
                    <div class="text-xs text-pink-800 mt-1">Consultar grupo</div>
                  </div>

                  <div class="bg-gradient-to-br from-indigo-400 to-indigo-500 rounded-xl p-4 text-center shadow-md">
                    <div class="text-2xl mb-2">✨</div>
                    <div class="text-sm font-bold text-indigo-900">8º Lugar</div>
                    <div class="text-xs text-indigo-800 mt-1">Consultar grupo</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationMenu from '@/components/NavigationMenu';
import NavigationBetting from '@/components/NavigationBetting';

export default {
  name: 'BetRules',
  components: {
    NavigationMenu,
    NavigationBetting
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  }
}
</script>